import React from 'react';

/** Lucide-style demand arrows — pairs with tee-time pricing meter chips. */
export function DemandTrendArrowIcon({
  direction,
  sizePx,
  stroke,
  strokeWidth,
}: {
  direction: 'lower' | 'higher';
  sizePx: number;
  stroke: string;
  strokeWidth: number;
}) {
  const cap: React.SVGProps<SVGPathElement> = {
    stroke,
    strokeWidth,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    fill: 'none',
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={sizePx}
      height={sizePx}
      viewBox="0 0 24 24"
      aria-hidden
      style={{ flexShrink: 0, display: 'block' }}
    >
      {direction === 'lower' ? (
        <>
          <path d="M12 5v14" {...cap} />
          <path d="m19 12-7 7-7-7" {...cap} />
        </>
      ) : (
        <>
          <path d="m5 12 7-7 7 7" {...cap} />
          <path d="M12 19V5" {...cap} />
        </>
      )}
    </svg>
  );
}

const PROMO_SPARKLE_PATH_D =
  'M7.50002 7.49996H7.50835M12.5 12.5H12.5084M13.3334 6.66663L6.66669 13.3333M14.9177 4.16538C15.0893 4.5804 15.4187 4.91029 15.8334 5.08252L17.2877 5.68494C17.7028 5.85686 18.0325 6.18662 18.2044 6.60168C18.3763 7.01673 18.3763 7.48308 18.2044 7.89813L17.6025 9.35146C17.4305 9.7667 17.4302 10.2335 17.603 10.6486L18.2039 12.1015C18.2891 12.307 18.333 12.5274 18.3331 12.7499C18.3331 12.9725 18.2893 13.1928 18.2041 13.3984C18.119 13.604 17.9941 13.7908 17.8368 13.9482C17.6794 14.1055 17.4925 14.2303 17.2869 14.3154L15.8336 14.9173C15.4186 15.089 15.0888 15.4183 14.9165 15.8331L14.3141 17.2875C14.1422 17.7025 13.8125 18.0323 13.3974 18.2042C12.9824 18.3761 12.5161 18.3761 12.101 18.2042L10.6478 17.6022C10.2327 17.4307 9.76654 17.4311 9.35175 17.6032L7.89743 18.2048C7.48262 18.3763 7.0167 18.3761 6.60199 18.2044C6.18729 18.0326 5.85773 17.7032 5.6857 17.2886L5.08312 15.8338C4.91152 15.4188 4.58214 15.0889 4.16739 14.9166L2.71307 14.3142C2.29822 14.1424 1.96857 13.8128 1.79659 13.398C1.62461 12.9832 1.62438 12.5171 1.79594 12.1021L2.39791 10.6488C2.5694 10.2337 2.56905 9.7675 2.39693 9.3527L1.79583 7.89728C1.71061 7.69171 1.66672 7.47136 1.66669 7.24882C1.66665 7.02628 1.71046 6.80592 1.79562 6.60032C1.88078 6.39472 2.00562 6.20792 2.16299 6.05059C2.32037 5.89325 2.50721 5.76847 2.71282 5.68338L4.1661 5.08139C4.58075 4.90994 4.91042 4.58096 5.08277 4.16667L5.68517 2.7123C5.85709 2.29725 6.18683 1.96749 6.60187 1.79557C7.01691 1.62365 7.48324 1.62365 7.89828 1.79557L9.35156 2.39756C9.76661 2.56905 10.2328 2.5687 10.6476 2.39658L12.1025 1.7965C12.5175 1.62468 12.9837 1.62471 13.3987 1.7966C13.8136 1.96849 14.1433 2.29815 14.3153 2.7131L14.9179 4.1679L14.9177 4.16538ZM7.91669 7.49996C7.91669 7.73008 7.73014 7.91663 7.50002 7.91663C7.2699 7.91663 7.08335 7.73008 7.08335 7.49996C7.08335 7.26984 7.2699 7.08329 7.50002 7.08329C7.73014 7.08329 7.91669 7.26984 7.91669 7.49996ZM12.9167 12.5C12.9167 12.7301 12.7301 12.9166 12.5 12.9166C12.2699 12.9166 12.0834 12.7301 12.0834 12.5C12.0834 12.2698 12.2699 12.0833 12.5 12.0833C12.7301 12.0833 12.9167 12.2698 12.9167 12.5Z';

/** Promo sparkle / ticket icon (20×20 artboard); stroke matches demand meter (`cardInk`). */
export function PromoPricingGlyphIcon({
  sizePx,
  stroke,
  strokeWidth,
}: {
  sizePx: number;
  stroke: string;
  strokeWidth: number;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={sizePx}
      height={sizePx}
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden
      style={{ flexShrink: 0, display: 'block' }}
    >
      <path
        d={PROMO_SPARKLE_PATH_D}
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
